// extracted by mini-css-extract-plugin
module.exports = {"noiseBgLight":"ConversionPanelV2_noiseBgLight__vweVd","noiseBgDark":"ConversionPanelV2_noiseBgDark__kCgzN","wavesBg":"ConversionPanelV2_wavesBg__phQZ_"};